import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { CTA_CLICKED } from '@constants/queryParams';
import { CTA_CLICKED_JOURNEY } from '@constants/storageKeys';

const TRUTHY_VALUE = 'true';

const isCtaJourney = () =>
  localStorage.getItem(CTA_CLICKED_JOURNEY) === TRUTHY_VALUE;
const setStorage = () =>
  localStorage.setItem(CTA_CLICKED_JOURNEY, TRUTHY_VALUE);
const clearStorage = () => localStorage.removeItem(CTA_CLICKED_JOURNEY);

const useHandleCTAConversionParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const checkQueryParams = useCallback(() => {
    const ctaClickedParam = searchParams.get(CTA_CLICKED);

    if (ctaClickedParam === TRUTHY_VALUE) {
      setSearchParams({});
      setStorage();
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    checkQueryParams();
  }, [checkQueryParams]);

  return {
    clearCTAConversionFlag: clearStorage,
    isCTAConversionJourney: isCtaJourney(),
  };
};

export { useHandleCTAConversionParam };
